import { render, staticRenderFns } from "./websiteInvest.vue?vue&type=template&id=b7ceb56e&scoped=true&"
import script from "./websiteInvest.vue?vue&type=script&lang=js&"
export * from "./websiteInvest.vue?vue&type=script&lang=js&"
import style0 from "./websiteInvest.vue?vue&type=style&index=0&id=b7ceb56e&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "b7ceb56e",
  null
  
)

export default component.exports